import React from 'react';
import { TermsOfServiceContent } from '../legal/TermsOfServiceContent';
import { EFFECTIVE_DATE } from '../legal/constants';

/**
 * TermsAndConditionsModal - Modal displaying the Terms of Service
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 */
export function TermsAndConditionsModal({ isOpen, onClose }) {
    if (!isOpen) {
        return null;
    }

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <div>
                        <h2 className="text-2xl font-bold text-gray-800">Terms of Service</h2>
                        <p className="text-sm text-gray-500 mt-1">Effective {EFFECTIVE_DATE}</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition"
                        aria-label="Close"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className="overflow-y-auto p-6 flex-1">
                    <TermsOfServiceContent variant="modal" />
                </div>

                <div className="flex justify-end p-6 border-t border-gray-200">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 rounded bg-[#3498db] hover:bg-[#2980b9] text-white transition"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
